angular.module('shared').factory('ContactCommunicationService', ["$q", "$http", "TemplateSanitizeService", function($q, $http, TemplateSanitizeService) {
  return {
    send: function(gymId, contactId, template, recipientsIds) {
      var data, deferred, url;
      deferred = $q.defer();
      template = TemplateSanitizeService.sanitize(template);
      template.contact_comms_recipient_ids = template.channel === 'push_notification' ? void 0 : recipientsIds;
      data = {
        template: template
      };
      url = `gyms/${gymId}/contacts/${contactId}/communicate`;
      $http({
        method: 'POST',
        url: url,
        data: data
      }).success(function(data) {
        return deferred.resolve(data);
      }).error(function(data) {
        var error;
        error = (function() {
          var ref, ref1;
          try {
            return ((ref = data.attributes.errors) != null ? ref.contact[0] : void 0) || ((ref1 = data.attributes.template) != null ? ref1.errors.contact[0] : void 0);
          } catch (error1) {
            return 'Sorry, the message was not sent';
          }
        })();
        return deferred.reject(error);
      });
      return deferred.promise;
    }
  };
}]);
